export default "/images/gardening_sm.jpg?c2369b2b6a36710ca70ed5a7052fdc80";